import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:my-24 mt-3 grid gap-y-5" }
const _hoisted_2 = {
  id: "organizations-header",
  class: "flex items-center justify-between"
}
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = {
  id: "organization-div-table",
  class: "bg-white rounded-lg border border-gray-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Organizações", en: "Organizations" })), 1),
      _createVNode(_component_Button, {
        class: "btn-primary p-button-sm",
        id: "btn-add-organizations",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectTo('formsOrganizations')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { name: "md-add" }),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Cadastrar organizações",
              en: "Add organizations",
            })), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        slotData: _ctx.organizations,
        columns: _ctx.columns,
        actions: _ctx.actions,
        loading: _ctx.loading,
        params: _ctx.params,
        filters: _ctx.filters,
        hasStatus: true,
        onOnEdit: _cache[2] || (_cache[2] = (e) => _ctx.goToEdit(e)),
        onOnTheme: _cache[3] || (_cache[3] = (e) => _ctx.goToTheme(e)),
        onOnChangeStatus: _cache[4] || (_cache[4] = (e) => _ctx.confirmModal(e)),
        onOnPaginate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.paginate($event))),
        onOnToggleFilter: _cache[6] || (_cache[6] = (e, type) => _ctx.toggleFilter(e, type)),
        onOnFilter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterFor())),
        onOnClearFilter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearFilter()))
      }, {
        filters: _withCtx(() => [
          (_ctx.filterType == 'name')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                modelValue: _ctx.filters.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.name) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["slotData", "columns", "actions", "loading", "params", "filters"])
    ]),
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } })
  ]))
}